import * as React from "react";
import { Box, Container } from "@mui/material";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ACIDTech from "./ACIDTech";
import InjecSolution from "./InjecSolution";
import SliderImage from "./SliderImage";

export default function NestedList() {
  const [open, setOpen] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState("ACID Tech");

  const handleClick = (item) => {
    setSelectedItem(item);
    setOpen(item === "Inbox" ? !open : false); // Close the dropdown when clicking on the Inbox item
  };

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap",flexDirection:"column" }}>
      <SliderImage />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "column", md: "row" },
          pt: { xs: 4, sm: 12 },
          pb: { xs: 8, sm: 16 },
        }}
      >
        <List
          sx={{
            maxWidth: "100%",
            width: { sm: "100%", md: 340 },
            bgcolor: "background.paper",
          }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          // subheader={
          //   <ListSubheader component="div" id="nested-list-subheader">
          //     Technology
          //   </ListSubheader>
          // }
        >
          <ListItemButton onClick={() => handleClick("ACID Tech")}>
            <ListItemText primary="AICD Technology" />
          </ListItemButton>
          <ListItemButton onClick={() => handleClick("InjecSolution")}>
            <ListItemText primary="Intelligent layered water injection Solution" />
          </ListItemButton>
        </List>

        {selectedItem === "ACID Tech" && <ACIDTech />}

        {selectedItem === "InjecSolution" && <InjecSolution />}
      </Box>
    </Box>
  );
}
